import React from 'react';
import Icon from './Icon';

// Accept addr as either a string ("street, city, state zip" from the static
// content module) or an array of lines (from live.js). Normalize to array.
function normalizeAddr(addr) {
  if (Array.isArray(addr)) return addr.filter(Boolean);
  if (typeof addr !== 'string' || !addr) return [];
  const idx = addr.indexOf(', ');
  if (idx === -1) return [addr];
  return [addr.slice(0, idx), addr.slice(idx + 2)];
}

export default function AttendeeRow({ attendee }) {
  const initials = `${attendee.first?.[0] || ''}${attendee.last?.[0] || ''}`.toUpperCase();
  const phoneDigits = attendee.phone ? attendee.phone.replace(/\D/g, '') : '';
  const addrLines = normalizeAddr(attendee.addr);

  return (
    <div className="portal-attendee-row">
      <div className={`portal-avatar${attendee.legacy ? ' legacy' : ''}${attendee.guest ? ' guest' : ''}`} aria-hidden>
        {initials}
      </div>
      <div className="portal-attendee-main">
        <div className="portal-attendee-name-row">
          <span className="portal-attendee-name">{attendee.first} {attendee.last}</span>
          {attendee.legacy && <span className="portal-legacy-chip">Legacy</span>}
          {attendee.guest && <span className="portal-guest-chip">Guest</span>}
        </div>
        {attendee.role && <div className="portal-attendee-role">{attendee.role}</div>}
        {attendee.org && <div className="portal-attendee-org">{attendee.org}</div>}

        {(attendee.phone || attendee.email || addrLines.length > 0) && (
          <div className="portal-attendee-contact">
            {attendee.phone && (
              <a href={`tel:${phoneDigits}`} className="portal-attendee-contact-row">
                <Icon name="phone" size={14} className="portal-attendee-contact-icon" />
                <span>{attendee.phone}</span>
              </a>
            )}
            {attendee.email && (
              <a href={`mailto:${attendee.email}`} className="portal-attendee-contact-row portal-attendee-contact-email">
                <Icon name="mail" size={14} className="portal-attendee-contact-icon" />
                <span>{attendee.email}</span>
              </a>
            )}
            {addrLines.length > 0 && (
              <div className="portal-attendee-contact-row portal-attendee-addr">
                <Icon name="map-pin" size={14} className="portal-attendee-contact-icon" />
                <span>
                  {addrLines.map((line, i) => (
                    <React.Fragment key={i}>
                      {i > 0 && <br />}
                      {line}
                    </React.Fragment>
                  ))}
                </span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
